import { VIEWS_MODULE_NAMESPACE } from '@/constants/modules';

export const NAMESPACE = 'EmployeesModule';
export const FULL_NAMESPACE = `${VIEWS_MODULE_NAMESPACE}/CompanyAdminModule/${NAMESPACE}`;

export const STATUS_DEFAULT = {
  IDLE: true,
  FORM_INVALID: false,
  FORM_VALID: false,
  SEND_IN: false,
  SEND_SUCCESS: false,
  SEND_ERROR: false,
  DEACTIVATE_IN: false,
  DEACTIVATE_SUCESS: false,
  DEACTIVATE_ERROR: false,
};

export const INIT_STATE = {
  employeesEmails: '',
  employeesEmailsArray: [],
  employeeName: '',
  isActivation: false,
  STATUS: Object.assign({}, STATUS_DEFAULT),
};

export default {
  namespaced: true,
  state: INIT_STATE,
  mutations: {
    SET_STATUS(state, value) {
      const states = Object.keys(state.STATUS);

      if (states.indexOf(value) > -1) {
        states.forEach((key) => {
          state.STATUS[key] = (key === value);
        });
      } else {
        // TODO:
        // Improve this?
      }
    },
    SET_EMPLOYEES_EMAILS(state, employeesEmails) {
      state.employeesEmails = employeesEmails;
    },
    SET_EMPLOYEES_EMAILS_ARRAY(state, employeesEmailsArray) {
      state.employeesEmailsArray = employeesEmailsArray;
    },
    SET_EMPLOYEE_NAME(state, employeeName) {
      state.employeeName = employeeName;
    },
    SET_IS_ACTIVATION(state, isActivation) {
      state.isActivation = isActivation;
    },
    RESET_STORE(state /* , value */) {
      state.STATUS = Object.assign({}, STATUS_DEFAULT);
      state.employeesEmails = '';
      state.employeesEmailsArray = [];
      state.employeeName = '';
      state.isActivation = false;
    },
  },
  actions: {
    async deactivateEmployees({
      rootState,
      state,
      commit,
    }, {
      employeeUuid,
      isActivation,
      employeeName,
    }) {
      const api = rootState.Setup.apiInstance;

      if (state.STATUS.IDLE) {
        commit('SET_STATUS', 'DEACTIVATE_IN');
        commit('SET_EMPLOYEE_NAME', employeeName);
        commit('SET_IS_ACTIVATION', isActivation);

        const localParams = {
          userUUID: employeeUuid,
          isActivation,
        };

        try {
          await api.deactivateEmployee(localParams);
          commit('SET_STATUS', 'DEACTIVATE_SUCESS');
        } catch (error) {
          commit('SET_STATUS', 'DEACTIVATE_ERROR');
        }

        commit('SET_EMPLOYEE_NAME', '');
        commit('SET_IS_ACTIVATION', false);
        commit('SET_STATUS', 'IDLE');
      }
    },
    async sendEmployeesEmails({
      state,
      rootState,
      commit,
    }) {
      const api = rootState.Setup.apiInstance;
      if (state.STATUS.FORM_VALID) {
        commit('SET_STATUS', 'SEND_IN');

        const localParams = {
          userUUID: rootState.App.UserAccount.data.uuid,
          emailArray: state.employeesEmailsArray,
        };

        try {
          await api.invitateEmployees(localParams);
          commit('SET_STATUS', 'SEND_SUCCESS');
        } catch (error) {
          commit('SET_STATUS', 'SEND_ERROR');
        }
      }
    },
    cleanEmployeesEmails: ({ commit }) => {
      commit('SET_EMPLOYEES_EMAILS', '');
      commit('SET_EMPLOYEES_EMAILS_ARRAY', []);
      commit('SET_STATUS', 'IDLE');
    },
    updateEmployeesEmails: ({ commit }, { employeesEmails }) => {
      const employeesEmailsSanitize = employeesEmails.replace(/\n/g, '').replace(/ /g, '');
      const employeesEmailsArray = (employeesEmailsSanitize === '') ? [] : employeesEmailsSanitize.split(',');

      const isCorrectEmail = (email) => {
        // eslint-disable-next-line
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      };

      let i = 0;

      while (i < employeesEmailsArray.length && isCorrectEmail(employeesEmailsArray[i])) {
        i += 1;
      }

      const valid = (i === employeesEmailsArray.length) && employeesEmailsArray.length;
      if (valid) {
        commit('SET_EMPLOYEES_EMAILS', employeesEmails);
        commit('SET_EMPLOYEES_EMAILS_ARRAY', employeesEmailsArray);
        commit('SET_STATUS', 'FORM_VALID');
      } else {
        commit('SET_EMPLOYEES_EMAILS', employeesEmails);
        commit('SET_EMPLOYEES_EMAILS_ARRAY', employeesEmailsArray);
        commit('SET_STATUS', 'FORM_INVALID');
      }
    },
  },
};
